<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="null" />
    <!--    头部end-->
    <div class="personal-box">
      <div class="personal-left">
        <div class="personal-head" v-if="userInfo.id">
          <img v-if="userInfo.avatar && userInfo.avatar.url != undefined" :src="userInfo.avatar.url" class="head"/>
          <img
            class="head"
            v-else
            src="@/assets/images/user.png"
            alt="默认头像"
          />
          <div class="name">{{ userInfo.doctor.doctorName }}</div>
          <img v-if="userInfo.doctor.authentication == 'A3' || userInfo.doctor.authentication == 'A0'" src="@/assets/images/Certification1.png" class="cer"/>
          <img v-if="userInfo.doctor.authentication == 'A1'" src="@/assets/images/Certification.png" class="cer"/>
          <img v-if="userInfo.doctor.authentication == 'AA'" src="@/assets/images/Certification7.png" class="cer"/>
          <img v-if="userInfo.doctor.authentication == 'A2'" src="@/assets/images/Certification8.png" class="cer"/>
          <div class="personal-label">{{ userInfo.doctor.hospital }} {{ userInfo.doctor.position }}</div>
        </div>
        <div class="personal-nav">
          <div class="nav-li ic1" :class="{ active: activeIndex === 1 }" @click="activeIndex = 1">学习进度</div>
          <div class="nav-li ic2" :class="{ active: activeIndex === 2 }" @click="activeIndex = 2">浏览历史</div>
          <div class="nav-li ic3" :class="{ active: activeIndex === 3 }" @click="activeIndex = 3">我的收藏</div>
          <div class="nav-li ic4" :class="{ active: activeIndex === 4 }" @click="activeIndex = 4">我的评论</div>
          <div class="nav-li ic7" :class="{ active: activeIndex === 7 }" @click="activeIndex = 7">我的点赞</div>
          <div class="nav-li ic8" :class="{ active: activeIndex === 8 }" @click="activeIndex = 8">我的分享</div>
          <div class="nav-li ic5" :class="{ active: activeIndex === 5 }" @click="activeIndex = 5">资质认证</div>
          <div class="nav-li ic6" :class="{ active: activeIndex === 6 }" @click="activeIndex = 6">消息中心</div>
          <div class="nav-li ic9" :class="{ active: activeIndex === 9 }" @click="activeIndex = 9">意见反馈</div>
          <div class="nav-li ic10" :class="{ active: activeIndex === 10 }" @click="activeIndex = 10">系统设置</div>
        </div>
      </div>
      <div class="personal-right">
        <!--学习进度-->
        <LearningProgress v-if="activeIndex === 1"/>
        <!--浏览历史-->
        <BrowseHistory v-if="activeIndex === 2"/>
        <!--我的收藏-->
        <MyCollection v-if="activeIndex === 3"/>
        <!--我的评论-->
        <MyComment v-if="activeIndex === 4"/>
        <!--资质认证-->
        <Qualification v-if="activeIndex === 5"/>
        <!--消息中心-->
        <MessageCenter v-if="activeIndex === 6"/>
        <!--我的点赞-->
        <MyPraise v-if="activeIndex === 7"/>
        <!--我的分享-->
        <MyShare v-if="activeIndex === 8"/>
        <!--意见反馈-->
        <Feedback v-if="activeIndex === 9"/>
        <!--系统设置-->
        <Settings v-if="activeIndex === 10"/>
      </div>
    </div>
    <footer-bar></footer-bar>
    <!--    页脚end-->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import LearningProgress from "@/views/PersonalCenter/components/LearningProgress.vue";
import BrowseHistory from "@/views/PersonalCenter/components/BrowseHistory.vue";
import MyCollection from "@/views/PersonalCenter/components/MyCollection.vue";
import MyComment from "@/views/PersonalCenter/components/MyComment.vue";
import Qualification from "@/views/PersonalCenter/components/Qualification.vue";
import MessageCenter from "@/views/PersonalCenter/components/MessageCenter.vue";
import MyPraise from "@/views/PersonalCenter/components/MyPraise.vue";
import MyShare from "@/views/PersonalCenter/components/MyShare.vue";
import Feedback from "@/views/PersonalCenter/components/Feedback.vue";
import Settings from "@/views/PersonalCenter/components/Settings.vue";

export default {
  name: "index",
  components: {FooterBar, headerBar, siteNav, LearningProgress, BrowseHistory, MyCollection, MyComment, Qualification, MessageCenter, MyPraise, MyShare, Feedback, Settings},
  data() {
    return {
      activeIndex: 1, // 默认选中第一个
      userInfo: {},
    }
  },
  methods: {

  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : {}
    if(this.$route.query.activeIndex) {
      this.activeIndex = Number(this.$route.query.activeIndex)
    }
  }
}
</script>
<style lang="less">
  .state-ul{
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(228, 231, 235, 1);
    height: 66px;
    padding: 0 24px;
    .state-li{
      color: rgba(68, 68, 68, 1);
      font-size: 18px;
      font-weight: bold;
      margin-right: 32px;
      cursor: pointer;
      height: 100%;
      line-height: 70px;
    }
    .state-li.active{
      position: relative;
      color: rgba(189, 24, 30, 1);
    }
    .state-li.active:before{
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      background: rgba(189, 24, 30, 1);
      height: 2px;
    }
  }
  .study-box{
    padding: 13px 24px;
  }
  .study-ul{
    .study-li{
      display: flex;
      align-items: center;
      padding: 10px 0;
      margin-top: 10px;
      .study-text{
        flex: 1;
        text-align: left;
        margin-left: 12px;
        .study-time{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .study-left{
            color: rgba(98, 99, 101, 1);
            font-size: 12px;
          }
          .study-right{
            color: rgba(255, 122, 2, 1);
            font-size: 12px;
          }
        }
        .study-title{
          color: rgba(34, 34, 34, 1);
          font-size: 15px;
          line-height: 22px;
          font-weight: bold;
          height: 44px;
          margin-bottom: 14px;
        }
      }
      .study-video{
        width: 126px;
        height: 82px;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
        img{
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;  /* 保持比例填充并裁剪 */
        }
      }
      .study-duration{
        position: absolute;
        background: rgba(0, 0, 0, 0.36);
        padding: 0 10px;
        border-radius: 4px;
        height: 20px;
        line-height: 20px;
        color: #fff;
        right: 4px;
        bottom: 4px;
        font-size: 12px;
      }
    }
  }
</style>
<style scoped lang="less">
  .personal-box{
    width: 1300px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    padding: 34px 0 50px 0;
  }
  .personal-left{
    width: 289px;
    .personal-label{
      color: rgba(68, 68, 68, 1);
      font-size: 12px;
    }
  }
  .personal-right{
    width: 987px;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
  }
  .personal-nav{
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding: 8px 0 2px 0;
    .nav-li{
      height: 48px;
      line-height: 48px;
      padding-left: 66px;
      text-align: left;
      color: rgba(34, 34, 34, 1);
      font-size: 16px;
      margin-bottom: 14px;
      font-weight: bold;
      cursor: pointer;
      border-left:3px solid #fff;
    }
    .nav-li.ic1{
      background: url("~@/assets/images/m-1.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic1.active{
      background: url("~@/assets/images/m-1a.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic1:hover{
      background: url("~@/assets/images/m-1a.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic2{
      background: url("~@/assets/images/m-2.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic2.active{
      background: url("~@/assets/images/m-2a.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic2:hover{
      background: url("~@/assets/images/m-2a.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic3{
      background: url("~@/assets/images/m-3.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic3.active{
      background: url("~@/assets/images/m-3a.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic3:hover{
      background: url("~@/assets/images/m-3a.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic4{
      background: url("~@/assets/images/m-4.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic4.active{
      background: url("~@/assets/images/m-4a.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic4:hover{
      background: url("~@/assets/images/m-4a.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic5{
      background: url("~@/assets/images/m-5.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic5.active{
      background: url("~@/assets/images/m-5a.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic5:hover{
      background: url("~@/assets/images/m-5a.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic6{
      background: url("~@/assets/images/m-6.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic6.active{
      background: url("~@/assets/images/m-6a.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic6:hover{
      background: url("~@/assets/images/m-6a.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic7{
      background: url("~@/assets/images/m-7.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic7.active{
      background: url("~@/assets/images/m-7a.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic7:hover{
      background: url("~@/assets/images/m-7a.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic8{
      background: url("~@/assets/images/m-8.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic8.active{
      background: url("~@/assets/images/m-8a.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic8:hover{
      background: url("~@/assets/images/m-8a.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic9{
      background: url("~@/assets/images/m-9.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic9.active{
      background: url("~@/assets/images/m-9a.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic9:hover{
      background: url("~@/assets/images/m-9a.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic10{
      background: url("~@/assets/images/m-10.png") no-repeat 32px center;
      background-size: 18px 18px;
    }
    .nav-li.ic10.active{
      background: url("~@/assets/images/m-10.png") no-repeat 32px center;
      background-size: 18px 18px;
      border-left:3px solid rgba(189, 24, 30, 1);
      color: rgba(189, 24, 30, 1);
    }
    .nav-li.ic10:hover{
      background: url("~@/assets/images/m-10.png") no-repeat 32px center;
      background-size: 18px 18px;
      color: rgba(189, 24, 30, 1);
    }
  }
  .personal-head{
    text-align: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding: 24px 0;
    margin-bottom: 16px;
    .name{
      color: rgba(34, 34, 34, 1);
      font-size: 20px;
      font-weight: bold;
      line-height: 28px;
      margin-top: 8px;
      margin-bottom: 12px;
    }
    .head{
      width: 64px;
      height: 64px;
      border-radius: 50%;
      overflow: hidden;
    }
    .cer{
      width: 75px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/index.vue